import { request, Response } from '../utils';
import { Account } from '../types';

export const readAccount = (body: {
  username: string;
}): Response<{
  account: Account;
}> => request('read-account', body);
